export const sortVenueType = (venutypeList, venueTypeId, sortNumber) => {
  const venueType = venutypeList.filter(
    (venuetype) => venuetype.id === venueTypeId
  );
  venutypeList = venutypeList.filter(
    (venuetype) => venuetype.id !== venueTypeId
  );
  venutypeList.splice(sortNumber - 1, 0, venueType[0]);
  return venutypeList;
};
